import { gql } from '@apollo/client'

export default gql(`
query($id: ID!) {
    getStreamSchema(id: $id) {
        id
        levels {
            id
            group
            name
        }
    }
}`)
